// extracted by mini-css-extract-plugin
export default {"saveButton":"createSubAdminForm_saveButton__tmORC","input":"createSubAdminForm_input__KPxaC","select":"createSubAdminForm_select__ydzoV"};